import { render, staticRenderFns } from "./attendAddcoll.vue?vue&type=template&id=09fb831d&scoped=true&"
import script from "./attendAddcoll.vue?vue&type=script&lang=js&"
export * from "./attendAddcoll.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/common/nav.less?vue&type=style&index=0&id=09fb831d&scoped=true&lang=less&"
import style1 from "../../assets/css/common/form.less?vue&type=style&index=1&id=09fb831d&scoped=true&lang=less&"
import style2 from "../../assets/css/common/details.less?vue&type=style&index=2&id=09fb831d&scoped=true&lang=less&"
import style3 from "./attendAddcoll.vue?vue&type=style&index=3&id=09fb831d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fb831d",
  null
  
)

export default component.exports